export default __webpack_public_path__ + "static/O0174-110b5fffd54ef0394ff5a5cbe8a49b3c.png";